var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useReducer } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { RfpClientOneFileOneView } from '@/components/pages/rfp/client/RfpClientOneFileOneView';
import RfpOneArrowLink from '@/container/Client/Rfp/One/Parts/Head/RfpOneArrowLink';
import RfpContentSubMenu from '@/container/Client/Rfp/One/Parts/SubMenu/RfpContentSubMenu';
import { rfpOneUseCase } from '@/container/Client/Rfp/One/UseCase/RfpOneUseCase';
import Layout from '@/container/Layout';
import { isAdmin } from '@/helpers/auth';
import { useResourceUpload } from '@/hooks/file/useResource';
import { useResourceFromInput } from '@/hooks/file/useResourceView';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useRfpClientShareDocumentMessageFile } from '@/hooks/pages/rfp/client/useRfpClientShareDocumentMessageFile';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { initialState, reducer, } from '@/pages/rfp/client/RfpClientOneFileOne/RfpClientOneFileOneViewRequestReducer';
import { useRfpClientOneFileOneFetchMessage } from '@/pages/rfp/client/RfpClientOneFileOne/useRfpClientOneFileOneFetchMessage';
import { useRfpClientOneFileOneFetchViewRequest } from '@/pages/rfp/client/RfpClientOneFileOne/useRfpClientOneFileOneFetchViewRequest';
import { useRfpClientOneFileOneSubmit } from '@/pages/rfp/client/RfpClientOneFileOne/useRfpClientOneFileOneSubmit';
import { clientRfpOneFileOnePath } from '@/utils/router/links';
export const RfpClientOneFileOnePage = (props) => {
    var _a;
    const { fetchRfpOne, offers, profile, rfp, viewRequestId } = props;
    const history = useNavigate();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const auth = useTypeSelector((state) => state.auth);
    const isAdminUser = isAdmin(profile);
    // 閲覧申請一覧
    const [viewRequestState, viewRequestDispatch] = useReducer(reducer, initialState);
    const { isCanUpdateMember, isMemberAdmin, members } = rfpOneUseCase.useMemberInfo(rfp, profile, auth);
    // メッセージ一覧（右側メッセージの情報）
    const { chatItems, fetchMessage, hasInitialMessageData, loadingOfMessage, messageData, messageDispatch, user, } = useRfpClientOneFileOneFetchMessage({
        dispatch,
        id: rfp.id,
        profile,
        unmountRef,
        viewRequestId,
    });
    // 閲覧申請一覧（左側メニューの情報）
    const { displayLastMessage, fetchViewRequest, loadingOfViewRequest } = useRfpClientOneFileOneFetchViewRequest({
        dispatch,
        id: rfp.id,
        messageDispatch,
        unmountRef,
        viewRequestDispatch,
        viewRequestId,
    });
    const hasInitialViewRequest = viewRequestState !== null;
    // メッセージ送信処理
    const { onSubmit } = useRfpClientOneFileOneSubmit({
        dispatch,
        fetchMessage,
        fetchRfpOne,
        fetchViewRequest,
        id: rfp.id,
        unmountRef,
        viewRequestId,
    });
    const { inspectFileStatus, isUploading, uploadFileToStorage } = useResourceUpload({
        dispatch,
        unmountRef,
    });
    const { inputUploadFileEvent } = useResourceFromInput({
        fileType: 'object',
        uploadFileToStorage,
    });
    const { onClickFileLink } = useRfpClientShareDocumentMessageFile({
        dispatch,
        id: rfp.id,
        unmountRef,
    });
    /**
     * メッセージ一覧のアイテムをクリックした時の処理
     */
    const onClickItem = useCallback((value) => {
        // 別の一覧に移動
        history.replace(clientRfpOneFileOnePath(rfp.id, value));
    }, [rfp.id, history]);
    // 左側の閲覧申請情報を取得
    useEffect(() => {
        if (hasInitialViewRequest) {
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchViewRequest();
        }))();
    }, [hasInitialViewRequest, fetchViewRequest]);
    // 右側のメッセージ情報を取得
    useEffect(() => {
        if (hasInitialMessageData) {
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchMessage();
        }))();
    }, [hasInitialMessageData, fetchMessage]);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main rfp_common_container rfp_client_one_container' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${rfp.name}｜PROFFIT` }) }), _jsx(RfpClientOneFileOneView, { chatItems: chatItems, displayLastMessage: displayLastMessage, draftMessage: (_a = messageData === null || messageData === void 0 ? void 0 : messageData.draft_message) !== null && _a !== void 0 ? _a : null, hasUnRead: (messageData === null || messageData === void 0 ? void 0 : messageData.unread_count) > 0, id: rfp.id, isAdminUser: isAdminUser, isCallEnd: rfp.is_call_end, isDifferentUserForRequestProfessional: rfp.is_different_user_for_request_professional, isUploading: isUploading, items: viewRequestState || [], loadingOfMessage: loadingOfMessage, loadingOfViewRequest: loadingOfViewRequest, onClickDraft: onSubmit, onClickFileLink: onClickFileLink, onClickItem: onClickItem, onClickSubmit: onSubmit, onInspectFileStatus: inspectFileStatus, selectedId: viewRequestId, status: messageData === null || messageData === void 0 ? void 0 : messageData.status, stepComponent: _jsx(RfpOneArrowLink, { activeIndex: 1, offers: offers, rfp: rfp }), subContentComponent: _jsx(RfpContentSubMenu, { className: 'flex flex-col gap-y-32', isCanUpdateMember: isCanUpdateMember, isMemberAdmin: isMemberAdmin, members: members, rfp: rfp }), title: rfp.name, unansweredQuestionCount: rfp.unanswered_online_question_count, unapprovedCount: rfp.view_request_unapproved_count, unreadFileCount: rfp.unread_share_document_message_count, unreadMessageCount: rfp.view_request_unapproved_count, uploadFile: inputUploadFileEvent, user: user })] })));
};
